import React from 'react';
import { Nav } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const Sidebar = () => {
    const location = useLocation();
    const { user } = useAuth();

    const navItems = [
        { path: '/dashboard', icon: '📊', label: 'Dashboard' },
        { path: '/users', icon: '👥', label: 'Users' },
        { path: '/stores', icon: '🏪', label: 'Stores' },
        { path: '/vendors', icon: '🏢', label: 'Vendors' },
        { path: '/categories', icon: '🏷️', label: 'Categories' },
        { path: '/subcategories', icon: '🏷️', label: 'Subcategories' },
        { path: '/products', icon: '📦', label: 'Products' },
        { path: '/inventory', icon: '📊', label: 'Inventory' },
        { path: '/orders', icon: '📋', label: 'Orders' },
        { path: '/banners', icon: '🖼️', label: 'Banners' },
        { path: '/coupons', icon: '🎫', label: 'Coupons' },
    ];

    return (
        <div className="sidebar" style={{ width: '250px', minHeight: '100vh' }}>
            <div className="sidebar-header p-4 border-bottom">
                <h4 className="sidebar-logo fw-bold mb-0"> 🛒 SOHL CART</h4>
                <small className="sidebar-subtitle"> Admin Panel</small>
            </div>

            <div className="user-info p-3 border-bottom">
                <div className="d-flex align-items-center">
                    <div className="user-avatar rounded-circle d-flex align-items-center justify-content-center"
                        style={{ width: '40px', height: '40px' }}>
                        <span className="user-avatar-text">{user?.username?.charAt(0)?.toUpperCase() || 'A'}</span>
                    </div>
                    <div className="ms-3">
                        <div className="user-name fw-semibold">{user?.username || 'Admin'}</div>
                        <small className="user-role">{user?.role || 'Super Admin'}</small>
                    </div>
                </div>
            </div>

            <Nav className="sidebar-nav flex-column p-3">
                {navItems.map((item) => (
                    <Nav.Item key={item.path} className="mb-2">
                        <Link
                            to={item.path}
                            className={`sidebar-link d-flex align-items-center py-2 px-3 rounded ${location.pathname === item.path
                                ? 'sidebar-link-active'
                                : 'sidebar-link-inactive'
                                }`}
                            style={{ textDecoration: 'none' }}
                        >
                            <span className="sidebar-icon me-3 fs-5">{item.icon}</span>
                            <span className="sidebar-label">{item.label}</span>
                        </Link>
                    </Nav.Item>
                ))}
            </Nav>
        </div>
    );
};

export default Sidebar;